import React from 'react';
import styles from './PushPopUp.module.css';
import {NotificationResponseData, NotificationType} from '../../../types/notification';
import {
    ArchiveBoxIcon,
    BellIcon,
    CheckIcon,
    CurrencyDollarIcon,
    InformationCircleIcon,
    KeyIcon,
    Squares2X2Icon
} from '@heroicons/react/24/solid';
import {setReadAllNotificationAPI, setReadNotificationAPI} from "../../../services/notification";

interface PushPopUpProps {
    notifications: NotificationResponseData[];
    onClose: () => void;
    onUpdate: () => void;
}
//푸시 알림 팝업
const PushPopUp: React.FC<PushPopUpProps> = ({notifications, onClose, onUpdate}) => {

    //푸시 읽음 처리
    const handleReadNotification = async (notificationId: number) => {
        try {
            //푸시 읽음 처리 API
            await setReadNotificationAPI(notificationId);
            onUpdate();
        } catch (error) {
            console.error('Failed to mark notification as read:', error);
        }
    };

    //푸시 전체 읽음 처리
    const handleReadAll = async () => {
        try {
            //푸시 전체 읽음 처리 API
            await setReadAllNotificationAPI();
            onUpdate();
        } catch (error) {
            console.error('Failed to mark notification as read:', error);
        }
    }

    //푸시 알림 종류 별 아이콘 설정
    const getNotificationIcon = (type: NotificationType) => {
        const IconComponent = (() => {
            switch (type) {
                case NotificationType.PROJECT:
                    return Squares2X2Icon;
                case NotificationType.DOCUMENT:
                    return ArchiveBoxIcon;
                case NotificationType.BILLING:
                    return CurrencyDollarIcon;
                case NotificationType.ACCOUNT:
                    return KeyIcon;
                default:
                    return InformationCircleIcon;
            }
        })();

        return <IconComponent className={styles.typeIcon}/>;
    };

    //읽은 푸시, 안읽은 푸시 분리
    const unreadNotifications = notifications.filter(notification => !notification.isRead);
    const readNotifications = notifications.filter(notification => notification.isRead);

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.popup} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <BellIcon className={styles.bellIcon}/>
                        알림
                    </div>
                    {/*안내 문구*/}
                    <div className={styles.noti}>읽은 알림은 3일 후 삭제됩니다</div>
                    <button onClick={onClose} className={styles.closeButton}>
                        ×
                    </button>
                </div>
                <div className={styles.content}>
                    {notifications.length === 0 ? (
                        // 푸시 없는 경우
                        <div className={styles.empty}>알림이 없습니다</div>
                    ) : (
                        <>
                            {/*안읽은 푸시가 존재하는 경우*/}
                            {unreadNotifications.length > 0 && (
                                <>
                                    <div className={styles.unread}>
                                        <div className={styles.sectionTitle}>안 읽은 알림</div>
                                        {/*전체 읽음 처리 버튼*/}
                                        <button
                                            className={styles.checkAllButton}
                                            onClick={() => handleReadAll()}
                                            aria-label="Mark as read"
                                        >
                                            <CheckIcon className={styles.checkAllIcon}/>
                                        </button>
                                    </div>
                                    {unreadNotifications.map((notification) => (
                                        <div
                                            key={notification.notificationId}
                                            className={styles.notificationItem}
                                        >
                                            {getNotificationIcon(notification.notificationType)}
                                            <span className={styles.notificationText}>
                                                {/*푸시 제목*/}
                                                {notification.title}
                                            </span>
                                            {/*푸시 읽음 처리 버튼*/}
                                            <button
                                                className={styles.checkButton}
                                                onClick={() => handleReadNotification(notification.notificationId)}
                                                aria-label="Mark as read"
                                            >
                                                <CheckIcon className={styles.checkIcon}/>
                                            </button>
                                        </div>
                                    ))}
                                </>
                            )}
                            {/*읽은 푸시가 존재하는 경우*/}
                            {readNotifications.length > 0 && (
                                <>
                                    <div className={styles.sectionTitle}>읽은 알림</div>
                                    {readNotifications.map((notification) => (
                                        <div
                                            key={notification.notificationId}
                                            className={`${styles.notificationItem} ${styles.read}`}
                                        >
                                            {getNotificationIcon(notification.notificationType)}
                                            <span className={styles.notificationText}>
                                                {/*푸시 제목*/}
                                                {notification.title}
                                            </span>
                                        </div>
                                    ))}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PushPopUp;